import { fmtBRL } from "@/lib/medicoes";

const Row = ({ label, value, accent, testid, sub }) => (
  <div className="flex items-center justify-between py-2 border-b border-[#334155]/60 last:border-0">
    <span className={`text-sm ${sub ? "pl-4 text-[#94A3B8]" : "text-[#E9EEF5]"}`}>{label}</span>
    <span data-testid={testid} className="font-mono text-sm" style={accent ? { color: accent } : undefined}>{value}</span>
  </div>
);

export default function SaldoPanel({ resumo }) {
  if (!resumo) return null;
  const pct = Math.min(100, Math.max(0, resumo.pct_execucao || 0));
  return (
    <div className="tce-card p-6" data-testid="saldo-panel">
      <div className="uppercase-label !text-[#FFDF00] mb-4">Controle de saldo contratual</div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10">
        <div>
          <Row label="Valor original contratado" value={fmtBRL(resumo.valor_inicial)} testid="saldo-valor-inicial" />
          <Row sub label="Acréscimos (aditivos)" value={fmtBRL(resumo.acrescimos)} accent="#22C55E" />
          <Row sub label="Supressões (aditivos)" value={fmtBRL(resumo.supressoes)} accent="#EF4444" />
          <Row sub label="Reajustes / reequilíbrios" value={fmtBRL(resumo.reajustes)} />
          <Row label="Valor contratual atualizado" value={fmtBRL(resumo.valor_atualizado)} accent="#FFDF00" testid="saldo-valor-atualizado" />
        </div>
        <div>
          <Row label="Medições em elaboração" value={fmtBRL(resumo.valor_em_elaboracao)} testid="saldo-elaboracao" />
          <Row label="Medições submetidas (em trâmite)" value={fmtBRL(resumo.valor_submetido)} accent="#3B82F6" testid="saldo-submetido" />
          <Row label="Medições aprovadas" value={fmtBRL(resumo.valor_aprovado)} accent="#22C55E" testid="saldo-aprovado" />
          <Row label="Valor pago" value={fmtBRL(resumo.valor_pago)} accent="#10B981" testid="saldo-pago" />
          <Row label="Executado (liquidado no contrato)" value={fmtBRL(resumo.valor_executado)} testid="saldo-executado" />
          <Row label="Saldo disponível para novas medições" value={fmtBRL(resumo.saldo_disponivel)} accent="#FFDF00" testid="saldo-disponivel" />
        </div>
      </div>
      <div className="mt-5">
        <div className="flex justify-between text-xs text-[#94A3B8] mb-1.5">
          <span>Execução financeira</span><span data-testid="saldo-pct" className="font-mono">{pct.toFixed(2)}%</span>
        </div>
        <div className="h-2.5 rounded-full bg-[#1E293B] overflow-hidden">
          <div className="h-full bg-gradient-to-r from-[#009C3B] to-[#FFDF00] transition-[width] duration-700" style={{ width: `${pct}%` }} />
        </div>
        <p className="text-[11px] text-[#64748B] mt-2">
          Medições elaboradas ou submetidas não são contabilizadas como aprovadas ou pagas. O saldo disponível desconta as medições em trâmite.
        </p>
      </div>
    </div>
  );
}
